import createPersistedState from 'vuex-persistedstate';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')) : {
    count: 0,
    lists: [],
    currentCard: [],
    myReadingPlanList: [],
    user: {},
    readingPlanId: '',
    showMyBook: true,
    volunteer: {},
    showMenu: false,
    readingPlan: {},
  },
  mutations: {
    increase() {
      // eslint-disable-next-line no-plusplus
      this.state.count++;
    },
    addItem(state, value) {
      state.lists.push(value);
    },
  },
  actions: {

  },
});
